import './CalendrierHero.css';

export default function CalendrierHero() {
	return (
		<section className='formation-carte-hero'>
			<div className='formation-carte-hero__shape formation-carte-hero__shape--dots' />
			<div className='formation-carte-hero__shape formation-carte-hero__shape--lines' />
			<div className='formation-carte-hero__inner'>
				<h1 className='formation-carte-hero__title'>
					Calendrier des formations{' '}
				</h1>

				<div className='formation-carte-hero__breadcrumb'>
					<a href='/'>Home</a>
					<span>/</span>
					<span>Calendrier des formations </span>
				</div>
			</div>
		</section>
	);
}
